export default function getDomain() {
  const href = (document && document.location && document.location.href) || "";
  const match = href.match(
    /^https:\/\/[a-z]{2,32}\.((?:\w|[-]){5,32})\.[a-z]{2,3}/,
  );
  return (match && match[1]) || "lexicallabs";
}
